module.exports = [require("./.vercel/adapter-toolbar-script.js"),require("private-next-instrumentation-client-user")];
